import { getHotelScrapeList } from '@common/api/hotel';
import { useNotificationsStore } from '@common/store/notifications';
import { ScrapeQueryKeys } from '@common/types/query-keys';
import { useQuery } from '@tanstack/react-query';

export const useHotelScrapeList = (page?: number) => {
  const { addNotification } = useNotificationsStore();

  const { data, isLoading, error, isError } = useQuery({
    queryKey: [ScrapeQueryKeys.GET_HOTEL_SCRAPE_LIST, page],
    queryFn: () => {
      return getHotelScrapeList(page);
    },
    retry: false
  });

  if (isError) addNotification('fail', 'Failed to get hotel scrape list');

  return {
    hotelScrapeList: data?.data,
    isLoading,
    error
  };
};
